import { LogoMark } from "~/components/brand/logo-mark";

export function SidebarBrandMark() {
  return (
    <span className="flex size-7 shrink-0 items-center justify-center">
      <LogoMark decorative className="h-6 w-auto text-brand" />
    </span>
  );
}
